import { useContext, useState, useEffect } from "react";
import { StoreContext } from "../../store/Store";
import { GlobalRefContext } from "../../store/GlobalRefs";
import { getScreenshot } from "../../api/s3";
import { actionTypes } from "../../store/storeTypes";
import { Loader } from "../../components/Loader";

export const Flow = () => {
  const [store, dispatch] = useContext(StoreContext);
  const grefs = useContext(GlobalRefContext);
  const { auth, audit_flowSelection, flowConfig, mode, nodes } = store;
  const [keyedData, setKeyedData] = useState(null);
  const [loading, setLoading] = useState(null);

  const downloadScreenshot = (payload) => {
    if (payload.uploaded) {
      const asyncfunction = async () => {
        setLoading(payload.nodeId);
        const result = await getScreenshot(
          auth,
          payload.uploaded,
          payload.filetype
        );
        dispatch({
          type: actionTypes.SET_SCREENSHOT_IMAGE,
          payload: { active: true, image: result },
        });
        setLoading(null);
      };
      asyncfunction();
    }
  };

  const auditStyle = {
    width: "100%",
    // height: "100%",
    backgroundColor: flowConfig.layoutBackgroundColor,
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    flexDirection: "column",
    boxSizing: "border-box",
    overflowX: "auto",
    marginTop: 10,
    marginBottom: 10,
  };
  const taskStyle = {
    width: "70%",
    backgroundColor: "#ffffff",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    border: "1px solid black",
    borderRadius: 8,
    padding: 6,
    marginBottom: 10,
    marginTop: 10,
    boxSizing: "border-box",
  };
  const actionStyle = {
    backgroundColor: "black",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    border: "1px solid black",
    borderRadius: 8,
    padding: 6,
    boxSizing: "border-box",
    color: "#ffffff",
  };
  const screenshotStyle = {
    backgroundColor: "black",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    border: "1px solid black",
    borderRadius: 8,
    padding: 6,
    boxSizing: "border-box",
    gap: 40,
    color: "#ffffff",
  };
  const endStyle = {
    width: "70%",
    backgroundColor: "#DEE3E5",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    border: "1px solid #000000",
    borderRadius: 8,
    padding: 6,
    marginBottom: 10,
    marginTop: 10,
    boxSizing: "border-box",
    fontSize: 20,
    fontWeight: 700,
  };

  useEffect(() => {
    if (audit_flowSelection === "Audit") {
      //create keyed nodes
      const knodes = grefs.nodeCollectionRef.current.reduce((a, b) => {
        return { ...a, [b.id]: { text: b.data.text, type: b.data.type } };
      }, {});

      setKeyedData(knodes);
    }
  }, [audit_flowSelection, grefs.auditTrail, grefs.nodeCollectionRef, nodes]);

  const Task = ({ item, i }) => {
    return item.nodeId in keyedData ? (
      <div key={`t${i}`} style={taskStyle}>
        {keyedData[item.nodeId].text}
      </div>
    ) : null;
  };

  const Screenshot = ({ node, item, i }) => {
    return node && node.type === "screenshot" ? (
      item.filename ? (
        <>
          {loading === item.nodeId && (
            <div
              style={{ width: "100%", height: "100%", position: "relative" }}
            >
              <Loader width={40} />
            </div>
          )}
          <div
            key={`a${i}`}
            style={
              item.uploaded
                ? {
                    ...screenshotStyle,
                    color: "green",
                    border: "2px solid green",
                    backgroundColor: "#ffffff",
                    cursor: "pointer",
                    display: loading === item.nodeId ? "none" : "flex",
                  }
                : screenshotStyle
            }
            onClick={() => downloadScreenshot(item)}
          >
            <div>{`name: ${item.filename} `}</div>
            <div>{`type: ${item.filetype} `}</div>
            <div>{`size: ${item.filesize} `}</div>
          </div>
        </>
      ) : (
        <div key={`a${i}`} style={screenshotStyle}>
          <div>Nothing uploaded</div>
        </div>
      )
    ) : null;
  };
  const Select = ({ node, item, i }) => {
    return node && node.type === "select" ? (
      <div key={`a${i}`} style={actionStyle}>
        {`${item.target} selected`}
      </div>
    ) : null;
  };
  const Answer = ({ node, item, i }) => {
    return node && node.type === "question" ? (
      <div key={`a${i}`} style={actionStyle}>
        {item.button}
      </div>
    ) : null;
  };
  const Action = ({ item, i }) => {
    const node = keyedData[item.nodeId];
    return (
      <>
        <Answer node={node} item={item} i={i} />
        <Select node={node} item={item} i={i} />
        <Screenshot node={node} item={item} i={i} />
      </>
    );
  };
  const End = ({ item, i }) => {
    const node = keyedData[item.target];
    return node && node.type === "end" ? (
      <div key={`e${i}`} style={endStyle}>
        {node.text}
      </div>
    ) : null;
  };

  return mode === "flow" && audit_flowSelection === "Audit" && keyedData ? (
    <div style={auditStyle}>
      {grefs.auditTrail.current.map((item, i) => {
        return (
          <>
            <Task item={item} i={i} />
            <Action item={item} i={i} />
            <End item={item} i={i} />
          </>
        );
      })}
    </div>
  ) : null;
};
